// Added by Sejune Oh on 2020-07-07
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios, { AxiosResponse } from 'axios'

import { SiteConfig } from '@/helper/define/siteConfigDefine'

type ReqGetSiteConfigReturnValue = {
  items: SiteConfig[]
}

/**
 * Site의 모든 config 값들을 조회합니다.
 */
export async function reqGetSiteConfig(): Promise<AxiosResponse<ReqGetSiteConfigReturnValue>> {
  return await axios.get('v1/mgmt/env/site')
}

/**
 * 특정 DataStorage의 config 값을 조회합니다.
 * @param dsToken
 */
export async function reqGetDSSiteConfig(dsToken: string): Promise<AxiosResponse<ReqGetSiteConfigReturnValue>> {
  return await axios.get(`v1/mgmt/env/site?data_storage_token=${dsToken}`)
}

/**
 * Site의 config 값들을 업데이트 합니다.
 * @param {SiteConfig[]} configOptions
 */
export async function reqUpdateSiteConfg(configOptions: SiteConfig[]): Promise<AxiosResponse> {
  return await axios.put('v1/mgmt/env/site', {
    items: configOptions,
  })
}

export async function reqUpdateDSSiteConfig(configOptions: SiteConfig[], dsToken: string): Promise<AxiosResponse> {
  return await axios.put('v1/mgmt/env/site', {
    items: configOptions,
    data_storage_token: dsToken
  })
}

/**
 * cuvis export path를 체크합니다.
 */
export async function reqDirPathCheck(path: string): Promise<AxiosResponse> {
  return await axios.post(`/v1/mgmt/env/util/check-directory-path`, {
    dir_path: path,
  })
}

/**
 * DataStorage의 Config 파일을 삭제하여 Config를 초기화합니다.
 */
export async function reqResetDSSiteConfig(dsToken: string): Promise<AxiosResponse> {
  return await axios.post(`v1/mgmt/env/site:reset`,{
    data_storage_token: dsToken,
  })
}